<mat-sidenav-container fullscreen>
  <mat-sidenav-content>
  <app-backheader></app-backheader>
    <div class="main-content">
      

      <!-- offerDesign -->
      <!-- <div  class="offer_header active" >
        <div class="left" > 
          <a href='#cricket' [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['active']" [routerLink]="[ '/tabgames/1']"><img src="/assets/images/osgbook/ball.svg" id='cricket' alt=""></a> 
          <p id='cricket' > Cricket</p>
        </div>

        <div class="main">
          <a href='#soccer' [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['active']"  [routerLink]="[ '/tabgames/2']" class='target'>
          <img src="/assets/images/osgbook/soccer.svg"  id='soccer' alt="">
          </a>
          <p>Soccer</p>
        </div>

        <div class="right">
          <a href='#tennis'[routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['active']" [routerLink]="[ '/tabgames/3']" class='target'>
          <img src="/assets/images/osgbook/tennis.svg" id='tennis' alt="">
          </a>
          <p>Tennis</p>
        </div>
        <div class="main">
          <a href='#casino' [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['active']" [routerLink]="[ '/tabgames/4']" class='target'>
          <img src="/assets/images/osgbook/cards-header-icon.svg" id='casino' alt="">
          </a>
          <p>Slots</p>
        </div>
        <div class="main">
          <a href='#casino1' [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['active']" [routerLink]="[ '/tabgames/5']" class='target'>
          <img src="/assets/images/osgbook/chips-header-icon.svg" id='casino1' alt="">
          </a>

          <p>Live Casino</p>
        </div>
        <div class="main" >
          <a href='#casino2' [routerLinkActiveOptions]="{ exact: true }" [routerLinkActive]="['active']" [routerLink]="[ '/tabgames/6']" class='target'>
          <img src="/assets/images/osgbook/dice-header-icon.svg" id='casino2' alt="">
          </a>
          <p>Casino</p>
        </div>
        
      </div> -->


      <div style="margin-bottom: 8px;">
      </div>
      <!-- <div *ngIf="marquetext" class="marquee-text">
        <marquee width="100%" direction="left">{{marquetext}}</marquee>
      </div> -->

      <!-- Cricket -->
      <div *ngIf="id==1">
        <mat-tab-group class="tab-body" class="sport-details-tab">
          <mat-tab label="INPLAY" >
            <ng-container *ngIf="cricketData?.length">


              <div class="game-list-card">

                <div *ngFor="let x of cricketData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table class="tabledata"  *ngIf="x.marketBook.inplay == true">
                    <tr> 
                      <th style="text-align: center; width:25%;padding-top:20px">
                       
                       <div class="temflex"> <img   *ngIf="x?.imgArr" src="{{x?.imgArr[0]}}"  onerror="this.src='/assets/images/osgbook/ball.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/ball.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0].runnerName}}</small></p>
                      </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div>
                          VS
                        </div>
                        <div>
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>
                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex">
                        <img   *ngIf="x?.imgArr"  src="{{x?.imgArr[1]}}" onerror="this.src='/assets/images/osgbook/ball.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/ball.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1].runnerName}}</small></p>
                        </div>
                      </th>
                    </tr>
                  </table>
                </div>
                <div style="text-align: center;" *ngIf="!checkInplayStatus(cricketData[0].openDate)"  >
                  <span>No Matches Found !</span>
              </div>
 
              </div>
            </ng-container>
            <ng-container *ngIf="cricketData?.length == '0' ">
              <span  class ="notmatch"> No Match Found !</span>
                      </ng-container>
          </mat-tab>
          <mat-tab label="TODAY">
            <ng-container *ngIf="cricketData?.length">
              <div class="game-list-card">
                
                <div *ngFor="let x of cricketData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table class="tabledata" *ngIf="checkTodayStatus(x.openDate)">
                    <tr>
                      <th style="text-align: center; width:25%;padding-top:20px">
                        <div class="temflex"> <img   *ngIf="x?.imgArr" src="{{x?.imgArr[0]}}" onerror="this.src='/assets/images/osgbook/ball.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/ball.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0].runnerName}}</small></p>
                      </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div>
                          VS
                        </div>
                        <div>
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>

                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex"><img   *ngIf="x?.imgArr" src="{{x?.imgArr[1]}}" onerror="this.src='/assets/images/osgbook/ball.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/ball.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1].runnerName}}</small></p>
                      </div>
                      </th>

                    </tr>
                  </table>
                </div>
                <!-- <div style="text-align: center;" *ngIf="!checkTodayStatus(cricketData[0].openDate)"  >
                  <span>No Matches Found !</span>
              </div> -->
              </div>
            </ng-container>
            <ng-container *ngIf="cricketData?.length == '0' ">
              <div  class ="notmatch"> No Match Found !</div>
                      </ng-container>
          </mat-tab>
          <mat-tab label="UPCOMING">
            <ng-container *ngIf="cricketData?.length">
              <div class="game-list-card">
                <div class="game-list-header">
                  <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
                  Tomorrow
                  <!-- ({{cricketData?.length}}) -->
                  <!-- <mat-divider class="didvide" [vertical]="true"></mat-divider> -->
                </div>

                <div *ngFor="let x of cricketData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table *ngIf="checkTomorrowStatus(x.openDate)" class="tabledata">

                    <tr>
                      <th style="text-align: center; width:25%;padding-top:20px">
                        <div class="temflex"> <img   *ngIf="x?.imgArr" src="{{x?.imgArr[0]}}" onerror="this.src='/assets/images/osgbook/ball.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/ball.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0].runnerName}}</small></p>
                        </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div>
                          VS
                        </div>
                        <div>
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>

                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex">
                        <img   *ngIf="x?.imgArr" src="{{x?.imgArr[1]}}" onerror="this.src='/assets/images/osgbook/ball.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/ball.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1].runnerName}}</small></p>
                        </div>
                      </th>
                    </tr>
                  </table>
                </div>
                <!-- <div style="text-align: center;" *ngIf="cricketData[0].openDate < tomorrow"  >
                  <span>No Matches Found !</span>
              </div> -->

              </div>
            </ng-container>
            <ng-container *ngIf="cricketData?.length == '0' ">
              <div  class ="notmatch"> No Match Found !</div>
                      </ng-container>
          </mat-tab>
        </mat-tab-group>

      </div>
      <div *ngIf="id==2">
        <!-- Soccer -->
        <mat-tab-group class="tab-body" class="sport-details-tab">
          <mat-tab label="INPLAY">
        <ng-container *ngIf="soccerData?.length">
          <div class="game-list-card">
            

            <div  *ngFor="let x of soccerData" (click)="matchDetail(x.eventId, x.eventTypeId);">
              <table   *ngIf="x.marketBook.inplay == true" class="tabledata">
              <tr>
                <th style="text-align: center; width:25%;padding-top:20px">
                  <div class="temflex">  <img src="/assets/images/osgbook/soccer.svg"
                    class="flagimage">
                  <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0]?.runnerName}}</small></p>
                </div>  
                </th>
                <th style="text-align: center;width:50%;">
                  <small>{{x?.competitionName}}</small>
                  <div class="">
                    VS
                  </div>
                  <div >
                    <small class="timeshow">
                      {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                      {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                      {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                    </small>
                  </div>
                </th>
                <th style="text-align: center; width:25%;padding-top:20px;">
                  <div class="temflex">  <img src="/assets/images/osgbook/soccer.svg"
                    class="flagimage">
                  <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1]?.runnerName}}</small></p>
                  </div>
                </th>
              </tr>
              </table>
            </div>
            
          </div>
        </ng-container>
        <ng-container *ngIf="soccerData?.length == '0' ">
          <div  class ="notmatch"> No Match Found !</div>
                  </ng-container>
        </mat-tab>
        <mat-tab label="TODAY">
          <ng-container *ngIf="soccerData?.length">
            <div class="game-list-card">
  
              <div  *ngFor="let x of soccerData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                <table *ngIf="checkTodayStatus(x.openDate)" class="tabledata">
                <tr>
                  <th style="text-align: center; width:25%;padding-top:20px">
                    <div class="temflex"><img src="/assets/images/osgbook/soccer.svg"
                      class="flagimage">
                    <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0]?.runnerName}}</small></p>
                  </div>
                  </th>
                  <th style="text-align: center;width:50%;">
                    <small>{{x?.competitionName}}</small>
                    <div class="">
                      VS
                    </div>
                    <div >
                      <small class="timeshow">
                        {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                        {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                        {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                      </small>
                    </div>
                  </th>
                  <th style="text-align: center; width:25%;padding-top:20px;">
                    <div class="temflex">  <img src="/assets/images/osgbook/soccer.svg"
                      class="flagimage">
                    <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1]?.runnerName}}</small></p>
                    </div>
                  </th>
                </tr>
                </table>
              </div>
              <div style="text-align: center;" *ngIf="!checkTodayStatus(soccerData[0].openDate)"  >
                <span>No Matches Found !</span>
            </div>
            </div>
          </ng-container>
          <ng-container *ngIf="soccerData?.length == '0' ">
            <div  class ="notmatch"> No Match Found !</div>
                    </ng-container> 
        </mat-tab>
        <mat-tab label="UPCOMING">
          <ng-container *ngIf="soccerData?.length">
            <div class="game-list-card">
              <div class="game-list-header">
                <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
                Tomorrow
                <!-- ({{cricketData?.length}}) -->
                <!-- <mat-divider class="didvide" [vertical]="true"></mat-divider> -->
  
              </div>
  
              <div  *ngFor="let x of soccerData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                <table *ngIf="checkTomorrowStatus(x.openDate)" class="tabledata">
                <tr>
                  <th style="text-align: center; width:25%;padding-top:20px">
                    <div class="temflex"><img src="/assets/images/osgbook/soccer.svg"
                      class="flagimage">
                    <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0]?.runnerName}}</small></p></div>
                  </th>
                  <th style="text-align: center;width:50%;">
                    <small>{{x?.competitionName}}</small>
                    <div class="">
                      VS
                    </div>
                    <div >
                      <small class="timeshow">
                        {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                        {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                        {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                      </small>
                    </div>
                  </th>
                  <th style="text-align: center; width:25%;padding-top:20px;">
                    <div class="temflex"> <img src="/assets/images/osgbook/soccer.svg"
                      class="flagimage">
                    <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1]?.runnerName}}</small></p>
                    </div>
                  </th>
                </tr>
                </table>
              </div>
              <div style="text-align: center;" *ngIf="soccerData[0].openDate > tomorrow"  >
                <span>No Matches Found !</span>
            </div>
            </div>
          </ng-container>
          <ng-container *ngIf="soccerData?.length == '0' ">
            <div  class ="notmatch"> No Match Found !</div>
                    </ng-container>
        </mat-tab>

        </mat-tab-group>
      </div>


      <!-- Tennis -->
      <div *ngIf="id==3">
        <mat-tab-group class="tab-body" class="sport-details-tab">
          <mat-tab label="INPLAY">
        <ng-container *ngIf="tennisData?.length">
          <div class="game-list-card">


            <div  *ngFor="let x of tennisData" (click)="matchDetail(x.eventId, x.eventTypeId);">
              <table class="tabledata"  *ngIf="x.marketBook.inplay == true">
                <tr>
                  <th style="text-align: center; width:25%;padding-top:20px">
                    <div class="temflex"><img src="/assets/images/osgbook/tennis.svg"
                      class="flagimage">
                     
                    <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0]?.runnerName}}</small></p></div> 
                  </th>
                  <th style="text-align: center;width:50%;">
                    <small>{{x?.competitionName}}</small>
                    <div class="">
                      VS
                    </div>
                    <div >
                      <small class="timeshow">
                        {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                        {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                        {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                      </small>
                    </div>
                  </th>
                  <th style="text-align: center; width:25%;padding-top:20px;">
                    <div class="temflex"><img src="/assets/images/osgbook/tennis.svg"
                      class="flagimage">
                    <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1]?.runnerName}}</small></p>
                  </div>
                  </th>
                </tr>
              </table>
              
            </div>
            <!-- <div style="text-align: center;" *ngIf="!checkInplayStatus(tennisData[0].openDate)"  >
              <span>No Matches Found !</span>
          </div> -->
          </div>
        </ng-container>
        <ng-container *ngIf="tennisData?.length == '0' ">
          <div  class ="notmatch"> No Match Found !</div>
                  </ng-container>
        </mat-tab>
        <mat-tab label="TODAY">
          <ng-container *ngIf="tennisData?.length">
            <div class="game-list-card">

  
              <div  *ngFor="let x of tennisData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                <table class="tabledata" *ngIf="checkTodayStatus(x.openDate)">
                  <tr  >
                    <th style="text-align: center; width:25%;padding-top:20px">
                      <div class="temflex"><img src="/assets/images/osgbook/tennis.svg"
                        class="flagimage">
                        
                      <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0]?.runnerName}}</small></p>
                      </div>
                    </th>
                    <th style="text-align: center;width:50%;">
                      <small>{{x?.competitionName}}</small>
                      <div class="">
                        VS
                      </div>
                      <div >
                        <small class="timeshow">
                          {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                          {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                          {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                        </small>
                      </div>
                    </th>
                    <th style="text-align: center; width:25%;padding-top:20px;">
                      <div class="temflex"> <img src="/assets/images/osgbook/tennis.svg"
                        class="flagimage">
                      <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1]?.runnerName}}</small></p>
                      </div>
                    </th>
                  </tr>
                </table>
                
              </div>
              <!-- <div style="text-align: center;" *ngIf="!checkTodayStatus(tennisData[0].openDate)"  >
                <span>No Matches Found !</span>
            </div> -->
            </div>
          </ng-container>
          <ng-container *ngIf="tennisData?.length == '0' ">
            <div  class ="notmatch"> No Match Found !</div>
                    </ng-container>
          </mat-tab>
          <mat-tab label="UPCOMING">
            <ng-container *ngIf="tennisData?.length">
              <div class="game-list-card">
                <div class="game-list-header">
                  <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
                  Tomorrow
                  <!-- ({{cricketData?.length}}) -->
                  <!-- <mat-divider class="didvide" [vertical]="true"></mat-divider> -->
                </div>
                <div  *ngFor="let x of tennisData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table class="tabledata" *ngIf="checkTomorrowStatus(x.openDate)">
                    <tr>
                      <th style="text-align: center; width:25%;padding-top:20px">
                        <div class="temflex"> <img src="/assets/images/osgbook/tennis.svg"
                          class="flagimage">
                          
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0]?.runnerName}}</small></p>
                      </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div class="">
                          VS
                        </div>
                        <div >
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>
                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex"><img src="/assets/images/osgbook/tennis.svg"
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1]?.runnerName}}</small></p></div>  
                      </th>
                    </tr>
                  </table>
                  
                </div>
                <div style="text-align: center;font-size: 11px;" *ngIf="tennisData[0].openDate > tomorrow"  >
                  <span>No Matches Found !</span>
              </div>
              </div>
            </ng-container>
            <ng-container *ngIf="tennisData?.length == '0' ">
          <div  class ="notmatch"> No Match Found !</div>
                  </ng-container>
            </mat-tab>
        </mat-tab-group>
      </div>
<div *ngIf="id==4">
  <div class="game-list-card">
    <div class="game-list-header">
      <!-- <img src="/assets/images/osgbook/tennis.svg"   class="balimmage"> -->
      Slots
      <!-- ({{tennisData?.length}}) -->
      <mat-divider class="didvide" [vertical]="true"></mat-divider>
    </div>
    <ul class="casinolistgrid">
     
      <!-- <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 6244
                  </div>
        <img  class="imgsize" (click)="openCasino('SPB-aviator')" src="https://client.qtlauncher.com/images/?id=SPB-aviator_en_US&type=logo-square&version=1671525105358"
        alt=""> 
        <div class="game-detail"> <p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Aviator
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li> -->
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 3938
                  </div>
        <img  class="imgsize" (click)="openCasino('DS-aceydeucey')" src="https://client.qtlauncher.com/images/?id=DS-aceydeucey_en_US&type=logo-square&version=1663155620211"
        alt=""> 

        <div class="game-detail"> <p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Acey Deucey
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 9376
                  </div>
        <img  class="imgsize" (click)="openCasino('HAK-blocks')"  src="https://client.qtlauncher.com/images/?id=HAK-blocks_en_US&type=logo-square&version=1695090284433"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Blocks
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 8171
                  </div>
        <img  class="imgsize" (click)="openCasino('EVP-bombsquad')" src="https://client.qtlauncher.com/images/?id=EVP-bombsquad_en_US&type=banner&version=1580359967977"
        alt=""> 
        <div class="game-detail"> <p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Bomb Squad
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 170
                  </div>
        <img  class="imgsize" (click)="openCasino('EVP-bonanzawheel')"  src="https://client.qtlauncher.com/images/?id=EVP-bonanzawheel_en_US&type=banner&version=1627007856051"
        alt=""> 
        <div class="game-detail"> <p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Bonanza Wheel
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 2097
                  </div>
        <img  class="imgsize"  (click)="openCasino('WOO-spinthewheel')"  src="https://client.qtlauncher.com/images/?id=WOO-spinthewheel_en_US&type=logo-square&version=1672321747138"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Spin the Wheel
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 3488
                  </div>
        <img  class="imgsize"  (click)="openCasino('EVP-rollthedice')"  src="https://client.qtlauncher.com/images/?id=EVP-rollthedice_en_US&type=logo-square&version=1709649410399"
        alt=""> 
        <div class="game-detail"> <p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Roll the Dice
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 341
                  </div>
        <img  class="imgsize" (click)="openCasino('DS-laddergame')"  src="https://client.qtlauncher.com/images/?id=DS-laddergame_en_US&type=logo-square&version=1663187632616"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Ladder Game
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 5674
                  </div>
        <img  class="imgsize" (click)="openCasino('EVP-headsandtails')"  src="https://client.qtlauncher.com/images/?id=EVP-headsandtails_en_US&type=banner&version=1538453670896"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Heads & Tails
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 5L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 3070
                  </div>
        <img  class="imgsize" (click)="openCasino('KIR-igoalengland')"  src="https://client.qtlauncher.com/images/?id=KIR-igoalengland_en_US&type=logo-square&version=1656585205852"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          IGoal England
        </p>
        <p class="namecasino bottomi">
          ₹100 - 2L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 5074
                  </div>
        <img  class="imgsize" (click)="openCasino('EVP-mehen')"  src="https://client.qtlauncher.com/images/?id=EVP-mehen_en_US&type=banner&version=1612775531674"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Mehen
        </p>
        <p class="namecasino bottomi">
          ₹100 - 3L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 3120
                  </div>
        <img  class="imgsize" (click)="openCasino('EVP-pumpkinmaster')"  src="https://client.qtlauncher.com/images/?id=EVP-pumpkinmaster_en_US&type=logo-square&version=1698125393150"
        alt=""> 
        <div class="game-detail"><p class="namecasino">
          Casino
        </p> 
        <p class="namecasinom">
          Pumpkin Master
        </p>
        <p class="namecasino bottomi">
          ₹100 - 3L
        </p></div>
      </div></li>
  </ul>
   
    </div>
    <div style="margin-bottom:60px">

    </div>
</div>
<div *ngIf="id==5">
  <div class="game-list-card">
    <div class="game-list-header">
      <!-- <img src="/assets/images/osgbook/tennis.svg"   class="balimmage"> -->
    Live Casino
      <!-- ({{tennisData?.length}}) -->
      <mat-divider class="didvide" [vertical]="true"></mat-divider>
    </div>
    <ul  class="casinolistgrid">
      <li><div class="imgframe">

        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 9954
           </div>
        <img  class="imgsize" (click)="openCasino('EVO-americanroulette')" src="https://client.qtlauncher.com/images/?id=EVO-americanroulette_en_US&type=logo-square&version=1678358704943"
        alt=""> 
        <div class="game-detail"> <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          American Roulette
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 25L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 7467
                  </div>
        <img  class="imgsize"(click)="openCasino('EVO-autolightningroulette')"src="https://client.qtlauncher.com/images/?id=EVO-autolightningroulette_en_US&type=logo-square&version=1701277574098"
        alt=""> 
        <div class="game-detail"> <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Auto Lightning Roulette
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 25K
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 7668
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-autoroulettelapartage')" src="https://client.qtlauncher.com/images/?id=EVO-autoroulettelapartage_en_US&type=logo-square&version=1702450712159"
        alt=""> 
        <div class="game-detail">  <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Autoroulette La Partage
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 50K
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 5676
                  </div>
        <img  class="imgsize"  (click)="openCasino('EVO-bacbo')" src="https://client.qtlauncher.com/images/?id=EVO-bacbo_en_US&type=logo-square&version=1678359207526"
        alt=""> 
        <div class="game-detail">  <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Bac Bo
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 10L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 9880
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-baccarat')" src="https://client.qtlauncher.com/images/?id=EVO-baccarat_en_US&type=logo-square&version=1678359251397"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
         Evolution Gaming
        </p> 
        <p class="namecasinom">
          Baccarat
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 13L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 1703
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-blackjack')" src="https://client.qtlauncher.com/images/?id=EVO-blackjack_en_US&type=logo-square&version=1678359363992"
        alt=""> 
        <div class="game-detail">  <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Blackjack
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 25L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 9800
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-cashorcrash')" src="https://client.qtlauncher.com/images/?id=EVO-cashorcrash_en_US&type=logo-square&version=1678359497656"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Cash or Crash
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 5L
        </p>
        </div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 5077
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-craps')" src="https://client.qtlauncher.com/images/?id=EVO-craps_en_US&type=logo-square&version=1678360187701"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Craps
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 25L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 2107
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-crazycoinflip')" src="https://client.qtlauncher.com/images/?id=EVO-crazycoinflip_en_US&type=logo-square&version=1656329957231"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Crazy Coin Flip
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 25L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 4352
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-dragontiger')" src="https://client.qtlauncher.com/images/?id=EVO-dragontiger_en_US&type=logo-square&version=1678379304276"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Dragon Tiger
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 15L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 3490
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-dreamcatcher')" src="https://client.qtlauncher.com/images/?id=EVO-dreamcatcher_en_US&type=logo-square&version=1678379368909"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Dream Catcher
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 25L
        </p></div>
      </div></li>
      <li><div class="imgframe">
        <div class="usercount">
          <mat-icon class="material-icons sizecasino">people</mat-icon> 2177
                  </div>
        <img  class="imgsize" (click)="openCasino('EVO-fantan')" src="https://client.qtlauncher.com/images/?id=EVO-fantan_en_US&type=logo-square&version=1678379688682"
        alt=""> 
        <div class="game-detail">   <p class="namecasino">
          Evolution Gaming
        </p> 
        <p class="namecasinom">
          Fan Tan
        </p> 
        <p class="namecasino bottomi">
          ₹100 - 20L
        </p></div>
      </div></li>
  </ul>
   
    </div>
    <div style="margin-bottom:60px">

    </div>
</div>
<div *ngIf="id==6">
        <!-- =============================== -->
        <!-- PROVIDER TABS -->
        <!-- =============================== -->

        <div class="casino-provider-tabs" #providerTabsContainer>

          <button #providerTab type="button" *ngFor="let provider of casinoProviders; trackBy: trackByProvider"
            class="provider-tab" [class.active]="selectedProvider === provider.name"
            (click)="selectProvider(provider.name)">
            {{ provider.name }}
          </button>

        </div>


        <!-- =============================== -->
        <!-- CASINO GAMES -->
        <!-- =============================== -->

        <div class="casino-games">

          <div class="casino-card" *ngFor="let game of providerGames; trackBy: trackByGameId"
            (click)="opengapss(game?.gameId)">

            <!-- IMAGE -->
            <div class="casino-image">

              <img *ngIf="game?.urlThumb" [src]="game.urlThumb" [alt]="game?.gameName || 'Casino Game'"
                loading="lazy" />

              <div class="no-image" *ngIf="!game?.urlThumb">
                No Image
              </div>

            </div>


            <!-- INFO -->

            <div class="casino-info">

              <div class="casino-name">
                {{ game?.gameName|| '-' }}
              </div>

              <div class="casino-category">
                {{ game?.category || '-' }}
                <span *ngIf="game?.providerName">
                  ({{ game.providerName }}) {{game?.gameId}}
                </span>
              </div>

            </div>

          </div>

        </div>


        <div style="margin-bottom:60px">
        </div>
      </div>
      <div *ngIf="id==7">
        <mat-tab-group class="tab-body" class="sport-details-tab">
          <mat-tab label="INPLAY" >
            <ng-container *ngIf="kabbadiData?.length">
              <div class="game-list-card">
                <div class="game-list-header">
                  <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
                  Matches
                  <!-- ({{cricketData?.length}}) -->
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>

                </div>

                <div *ngFor="let x of kabbadiData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table class="tabledata"  *ngIf="x.marketBook.inplay == true">
                    <tr> 
                      <th style="text-align: center; width:25%;padding-top:20px">
                       
                       <div class="temflex"> <img   *ngIf="x?.imgArr" src="{{x?.imgArr[0]}}"  onerror="this.src='/assets/images/osgbook/sports-kabaddi-rounded.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/sports-kabaddi-rounded.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0].runnerName}}</small></p>
                      </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div>
                          VS
                        </div>
                        <div>
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>
                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex">
                        <img   *ngIf="x?.imgArr"  src="{{x?.imgArr[1]}}" onerror="this.src='/assets/images/osgbook/sports-kabaddi-rounded.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/sports-kabaddi-rounded.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1].runnerName}}</small></p>
                        </div>
                      </th>
                    </tr>
                  </table>
                </div>
                <div style="text-align: center;" *ngIf="!checkInplayStatus(kabbadiData[0].openDate)"  >
                  <span>No Matches Found !</span>
              </div>
 
              </div>
            </ng-container>
            <ng-container *ngIf="kabbadiData?.length == '0' ">
              <span  class ="notmatch"> No Match Found !</span>
                      </ng-container>
          </mat-tab>
          <mat-tab label="TODAY">
            <ng-container *ngIf="kabbadiData?.length">
              <div class="game-list-card">
                <div class="game-list-header">
                  <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
                  Matches
                  <!-- ({{cricketData?.length}}) -->
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </div>
                <div *ngFor="let x of kabbadiData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table class="tabledata" *ngIf="checkTodayStatus(x.openDate)">
                    <tr>
                      <th style="text-align: center; width:25%;padding-top:20px">
                        <div class="temflex"> <img   *ngIf="x?.imgArr" src="{{x?.imgArr[0]}}" onerror="this.src='/assets/images/osgbook/sports-kabaddi-rounded.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/sports-kabaddi-rounded.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0].runnerName}}</small></p>
                      </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div>
                          VS
                        </div>
                        <div>
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>

                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex"><img   *ngIf="x?.imgArr" src="{{x?.imgArr[1]}}" onerror="this.src='/assets/images/osgbook/sports-kabaddi-rounded.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/sports-kabaddi-rounded.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1].runnerName}}</small></p>
                      </div>
                      </th>

                    </tr>
                  </table>
                </div>
                <!-- <div style="text-align: center;" *ngIf="!checkTodayStatus(cricketData[0].openDate)"  >
                  <span>No Matches Found !</span>
              </div> -->
              </div>
            </ng-container>
            <ng-container *ngIf="kabbadiData?.length == '0' ">
              <div  class ="notmatch"> No Match Found !</div>
                      </ng-container>
          </mat-tab>
          <mat-tab label="UPCOMING">
            <ng-container *ngIf="kabbadiData?.length">
              <div class="game-list-card">
                <div class="game-list-header">
                  <!-- <img src="/assets/images/osgbook/ball.svg"   class="balimmage"> -->
                  Matches
                  <!-- ({{cricketData?.length}}) -->
                  <mat-divider class="didvide" [vertical]="true"></mat-divider>
                </div>

                <div *ngFor="let x of kabbadiData" (click)="matchDetail(x.eventId, x.eventTypeId);">
                  <table *ngIf="checkTomorrowStatus(x.openDate)" class="tabledata">

                    <tr>
                      <th style="text-align: center; width:25%;padding-top:20px">
                        <div class="temflex"> <img   *ngIf="x?.imgArr" src="{{x?.imgArr[0]}}" onerror="this.src='/assets/images/osgbook/sports-kabaddi-rounded.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/sports-kabaddi-rounded.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[0].runnerName}}</small></p>
                        </div>
                      </th>
                      <th style="text-align: center;width:50%;">
                        <small>{{x?.competitionName}}</small>
                        <div>
                          VS
                        </div>
                        <div>
                          <small class="timeshow">
                            {{moment(x?.openDate).utcOffset("+05:30").format('MMM')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('D')}}
                            {{moment(x?.openDate).utcOffset("+05:30").format('hh:mm a')}}
                          </small>

                        </div>
                      </th>
                      <th style="text-align: center; width:25%;padding-top:20px;">
                        <div class="temflex">
                        <img   *ngIf="x?.imgArr" src="{{x?.imgArr[1]}}" onerror="this.src='/assets/images/osgbook/sports-kabaddi-rounded.svg'"
                          class="flagimage">
                          <img  *ngIf="!x?.imgArr"  src='/assets/images/osgbook/sports-kabaddi-rounded.svg'
                          class="flagimage">
                        <p style="line-height: 12px;padding:4px;"><small>{{x?.runners[1].runnerName}}</small></p>
                        </div>
                      </th>
                    </tr>
                  </table>
                </div>
                <!-- <div style="text-align: center;" *ngIf="cricketData[0].openDate < tomorrow"  >
                  <span>No Matches Found !</span>
              </div> -->

              </div>
            </ng-container>
            <ng-container *ngIf="kabbadiData?.length == '0' ">
              <div  class ="notmatch"> No Match Found !</div>
                      </ng-container>
          </mat-tab>
        </mat-tab-group>

      </div>

<div *ngIf="id==8">
        <div class="game-list-card">
          
          <div class="col-center " style="margin-bottom:8vh">
            <div class="col s12 p-0 main-tabs">
              <div class="market-list">
                <div class="sk_homepageinplaymatch">
                  <div class="tabs-container">

                    <div class="tab" [class.active]="activeTab === 'all'" (click)="SetactiveTab('all')">
                      <i class="tab-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="5" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="8" y1="9" x2="12" y2="9"></line>
                          <line x1="8" y1="13" x2="14" y2="13"></line>
                          <line x1="14" y1="9" x2="17" y2="9"></line>
                        </svg>
                      </i>
                      <span>All Contest</span>
                    </div>

                    <div class="tab" [class.active]="activeTab === 'joined'" (click)="SetactiveTab('joined')">
                      <i class="tab-icon">
                        <svg width="18" height="18" fill="currentColor">
                          <path
                            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </svg>
                      </i>
                      <span>Joined Contest</span>
                    </div>

                    <div class="tab" [class.active]="activeTab === 'settled'" (click)="SetactiveTab('settled')">
                      <i class="tab-icon">
                        <svg width="18" height="18" fill="currentColor">
                          <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" fill="none" />
                        </svg>
                      </i>
                      <span>Settled Contest</span>
                    </div>

                  </div>

                  <div *ngIf="activeTab === 'all'">
                    <div *ngIf="ContestList?.length > 0; else noData">
                      <div *ngFor="let item of ContestList" class="Card">
                        <div class="sk_inplay-match vevent" (click)="Go(item.marketId)">
                          <div class="sk_inplay-match-left mobiledispaly">
                            <div class="sk_inplay-match-left-inner">
                              <div class="img-container">
                                <img src="https://adminapi.clubosg.com/uploads/banners/{{item.image}}" alt=""
                                  class="contest-image">
                              </div>

                              <div class="second">
                                <div class="sk_inplay-match-teamtitle">
                                  <div class="sk_inplay-match-titleiner">
                                    <div>
                                      <span class="sk_inplay-match-tamename">
                                        {{ item.eventName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div class="rightisdelist">
                                  <div class="sk_inplay-match-date">
                                    <div class="sk_inplay-matchday">
                                      {{ item.openDate | date: 'dd/MM/yyyy' }}
                                    </div>
                                    <div class="sk_inplay-match-time">
                                      {{ item.openDate | date: 'hh:mm a' }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>

                          <div class="sk_inplay-match-left desktopview">
                            <div class="sk_inplay-match-left-inner">
                              <div class="img-container">
                                <img src="https://adminapi.clubosg.com/uploads/banners/{{item.image}}" alt=""
                                  class="contest-image">
                              </div>
                              <div class="sk_inplay-match-teamtitle">
                                <div class="sk_inplay-match-titleiner">
                                  <div>
                                    <span class="sk_inplay-match-tamename">
                                      {{ item.eventName }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="sk_inplay-match-date">
                                <div class="sk_inplay-matchday">
                                  {{ item.openDate | date: 'dd/MM/yyyy' }}
                                </div>
                                <div class="sk_inplay-match-time">
                                  {{ item.openDate | date: 'hh:mm a' }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="sk_inplay-match-right">
                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Pool Price</div>
                              <div class="sk-match-coltxtsml">{{ item.poolPrice }}</div>
                            </div>

                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Entry Price</div>
                              <div class="sk-match-coltxtsml">{{ item.entryPrice }}</div>
                            </div>

                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Entry Commision</div>
                              <div class="sk-match-coltxtsml">{{ item.entryCommision }}</div>
                            </div>

                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Minimum to choose</div>
                              <div class="sk-match-coltxtsml">{{ item.option_allow }}</div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>


                    <ng-template #noData>
                      <div class="text-center py-3">
                        <h5>No Contests Available</h5>
                      </div>
                    </ng-template>
                  </div>

                  <div *ngIf=" activeTab === 'joined'">
                    <div *ngIf="ContestList?.length > 0; else noData">

                      <div *ngIf="activeTab === 'joined'">
                        <div *ngIf="ContestList?.length > 0; else noData">
                          <div *ngFor="let item of ContestList" class="Card">

                            <div class="sk_inplay-match vevent">
                              <!-- (click)="Go(item.market?.marketId)" -->
                              <!-- Mobile View -->
                              <div class="sk_inplay-match-left mobiledispaly">
                                <div class="sk_inplay-match-left-inner">
                                  <div class="img-container">
                                    <img src="https://adminapi.clubosg.com/uploads/banners/{{item.image}}"
                                      alt="Contest Banner" class="contest-image">
                                  </div>

                                  <div class="sk_inplay-match-teamtitle">
                                    <div class="sk_inplay-match-titleiner">
                                      <span class="sk_inplay-match-tamename">
                                        {{ item.market?.eventName || item.eventName }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="rightisdelist">
                                    <div class="sk_inplay-match-date">
                                      <div class="sk_inplay-matchday">
                                        {{ item.market?.openDate | date: 'dd/MM/yyyy' }}
                                      </div>
                                      <div class="sk_inplay-match-time">
                                        {{ item.market?.openDate | date: 'hh:mm a' }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Desktop View -->
                              <div class="sk_inplay-match-left desktopview">
                                <div class="sk_inplay-match-left-inner">
                                  <div class="img-container">
                                    <img src="https://adminapi.clubosg.com/uploads/banners/{{item.image}}"
                                      alt="Contest Banner" class="contest-image">
                                  </div>

                                  <div class="sk_inplay-match-teamtitle">
                                    <div class="sk_inplay-match-titleiner">
                                      <span class="sk_inplay-match-tamename">
                                        {{ item.market?.eventName || item.eventName }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="sk_inplay-match-date">
                                    <div class="sk_inplay-matchday">
                                      {{ item.market?.openDate | date: 'dd/MM/yyyy' }}
                                    </div>
                                    <div class="sk_inplay-match-time">
                                      {{ item.market?.openDate | date: 'hh:mm a' }}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Contest Info Section -->
                              <div class="sk_inplay-match-right">
                                <div class="sk_inplay-match-col-back">
                                  <div class="sk_inplay-match-coltxt">Pool Price</div>
                                  <div class="sk-match-coltxtsml">
                                    {{ item.market?.poolPrice || 0 }}
                                  </div>
                                </div>

                                <div class="sk_inplay-match-col-back">
                                  <div class="sk_inplay-match-coltxt">Entry Price</div>
                                  <div class="sk-match-coltxtsml">
                                    {{ item.market?.entryPrice || 0 }}
                                  </div>
                                </div>

                                <div class="sk_inplay-match-col-back">
                                  <div class="sk_inplay-match-coltxt">Entry Commission</div>
                                  <div class="sk-match-coltxtsml">
                                    {{ item.market?.entryCommision || 0 }}
                                  </div>
                                </div>

                                <div class="sk_inplay-match-col-back">
                                  <div class="sk_inplay-match-coltxt">Minimum to choose</div>
                                  <div class="sk-match-coltxtsml">
                                    {{ item.market?.option_allow || 0 }}
                                  </div>
                                </div>
                              </div>

                              <div class="sk_inplay-match-bet" style="width: 100%;">
                                <div class="options-grid">
                                  <div class="option-item" *ngFor="let option of item?.market?.runners; let i = index">
                                    <span class="options">{{ getOptionLabel(i) }}.</span>
                                    <input type="checkbox" (click)="$event.preventDefault()"
                                      [checked]="isOptionSelected(item.selectionName, option.runnerName)"
                                      style="opacity: 100; position: relative; left: 10px; " id="option{{ i }}" />
                                    <label for="option{{ i }}" style="margin-left: 10px; margin-bottom: 0px;">
                                      {{ option.runnerName }}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <ng-template #noData>
                        <p class="text-center mt-3">No contests joined yet.</p>
                      </ng-template>

                    </div>
                  </div>
                  <div *ngIf=" activeTab === 'settled'">
                    <div *ngIf="ContestList?.length > 0; else noData">


                      <div *ngFor="let item of ContestList" class="Card">

                        <div class="sk_inplay-match vevent">
                          <!-- (click)="Go(item.market?.marketId)" -->
                          <!-- Mobile View -->
                          <div class="sk_inplay-match-left mobiledispaly">
                            <div class="sk_inplay-match-left-inner">
                              <div class="img-container">
                                <img src="https://adminapi.clubosg.com/uploads/banners/{{item.image}}"
                                  alt="Contest Banner" class="contest-image">
                              </div>

                              <div class="sk_inplay-match-teamtitle">
                                <div class="sk_inplay-match-titleiner">
                                  <span class="sk_inplay-match-tamename">
                                    {{ item.market?.eventName || item.eventName }}
                                  </span>
                                </div>
                              </div>

                              <div class="rightisdelist">
                                <div class="sk_inplay-match-date">
                                  <div class="sk_inplay-matchday">
                                    {{ item.market?.openDate | date: 'dd/MM/yyyy' }}
                                  </div>
                                  <div class="sk_inplay-match-time">
                                    {{ item.market?.openDate | date: 'hh:mm a' }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Desktop View -->
                          <div class="sk_inplay-match-left desktopview">
                            <div class="sk_inplay-match-left-inner">
                              <div class="img-container">
                                <img src="https://adminapi.clubosg.com/uploads/banners/{{item.image}}"
                                  alt="Contest Banner" class="contest-image">
                              </div>

                              <div class="sk_inplay-match-teamtitle">
                                <div class="sk_inplay-match-titleiner">
                                  <span class="sk_inplay-match-tamename">
                                    {{ item.market?.eventName || item.eventName }}
                                  </span>
                                </div>
                              </div>

                              <div class="sk_inplay-match-date">
                                <div class="sk_inplay-matchday">
                                  {{ item.market?.openDate | date: 'dd/MM/yyyy' }}
                                </div>
                                <div class="sk_inplay-match-time">
                                  {{ item.market?.openDate | date: 'hh:mm a' }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Contest Info Section -->
                          <div class="sk_inplay-match-right">
                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Pool Price</div>
                              <div class="sk-match-coltxtsml">
                                {{ item.market?.poolPrice || 0 }}
                              </div>
                            </div>

                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Entry Price</div>
                              <div class="sk-match-coltxtsml">
                                {{ item.market?.entryPrice || 0 }}
                              </div>
                            </div>

                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Entry Commission</div>
                              <div class="sk-match-coltxtsml">
                                {{ item.market?.entryCommision || 0 }}
                              </div>
                            </div>

                            <div class="sk_inplay-match-col-back">
                              <div class="sk_inplay-match-coltxt">Minimum to choose</div>
                              <div class="sk-match-coltxtsml">
                                {{ item.market?.option_allow || 0 }}
                              </div>
                            </div>
                          </div>
                          <div class="Result-sec">

                            <div class="result">Result : <span style="margin-left: 2px;"
                                [ngClass]="item.result === 'WON' ? 't-green' : 't-red'">
                                {{item.result}}</span></div>
                            <div class="sk_inplay-match-bet" style="width: 100%;">
                              <div class="options-grid">
                                <div class="option-item" *ngFor="let option of item?.market?.runners; let i = index">
                                  <span class="options">{{ getOptionLabel(i) }}.</span>
                                  <input type="checkbox" (click)="$event.preventDefault()"
                                    [checked]="isOptionSelected(item.selectionName, option.runnerName)"
                                    style="opacity: 100; position: relative; left: 10px; " id="option{{ i }}" />
                                  <label for="option{{ i }}" style="margin-left: 10px;margin-bottom: 0px;">
                                    {{ option.runnerName }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-template #noData>
                    <div class="text-center py-3">
                      <h5>No Contests Available</h5>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
         <div *ngIf="id==9">
        <div class="game-list-card" >
          <div class="game-list-header">
            <!-- <img src="/assets/images/osgbook/tennis.svg"   class="balimmage"> -->
            <!-- player Battle -->
            <!-- ({{tennisData?.length}}) -->
            <!-- <mat-divider class="didvide" [vertical]="true"></mat-divider> -->

             <div class="col-center " style="margin-bottom:8vh; ">
            <div class="col s12 p-0 main-tabs">
              <div class="market-list">
                <div class="sk_homepageinplaymatch">
                   <div class="tabs-container">
                    <div class="tab" [class.active]="activePlayerTab === 'allc'" (click)="SetPlayeractiveTab('allc')">
                      <i class="tab-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="5" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="8" y1="9" x2="12" y2="9"></line>
                          <line x1="8" y1="13" x2="14" y2="13"></line>
                          <line x1="14" y1="9" x2="17" y2="9"></line>
                        </svg>
                      </i>
                      <span> All Events</span>
                    </div>

                    <div class="tab" [class.active]="activePlayerTab === 'joinedc'" (click)="SetPlayeractiveTab('joinedc')">
                      <i class="tab-icon">
                        <svg width="18" height="18" fill="currentColor">
                          <path
                            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </svg>
                      </i>
                      <span> Open Events</span>
                    </div>

                    <div class="tab" [class.active]="activePlayerTab === 'settledc'" (click)="SetPlayeractiveTab('settledc')">
                      <i class="tab-icon">
                        <svg width="18" height="18" fill="currentColor">
                          <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" fill="none" />
                        </svg>
                      </i>
                      <span>Settled Events</span>
                    </div>

                  </div>

<div *ngIf="activePlayerTab === 'allc'">
    <ng-container *ngIf="ContestPlayerList?.length > 0; else noData">
<div class="match-card" *ngFor="let item of ContestPlayerList" >

  <!-- HEADER -->
  <div class="match-header">
    <div class="left-badge">
      {{ item?.eventName.split('vs')[0].trim() }} vs {{ item?.eventName.split('vs')[1].trim() }}
    </div>
    <div class="right-area">
      <div class="date-badge">
        {{ item?.openDate | date:'dd MMM yyyy, hh:mm a' }}
      </div>

      <button class="rule-btn" (click)="openRules(rulesmodal)"> 
        <img src="../../assets/images/icon/rule.fdb64234.svg" />
      </button>
    </div>

  </div>

  <!-- DOTTED DIVIDER -->
  <div class="divider"></div>
<div (click)="GotoEventpage(item?.marketId)">
  <!-- COUNTDOWN BADGE -->
  <div class="countdown-badge" >
    {{ item.countdownText }}
  </div>

  <!-- TEAMS -->
  <div class="team-row" >

    <div class="team">
      <img src="../../assets/images/icon/Team.png" class="team-img imsgcard" />
      <span class="team-name">{{ item?.eventName.split('vs')[0].trim() }}</span>
    </div>

    <div class="vs-icon">vs</div>

    <div class="team">
      <span class="team-name">{{ item?.eventName.split('vs')[1].trim() }}</span>
      <img src="../../assets/images/icon/Team.png" class="team-img imsgcard" />
    </div>

  </div>
</div>
</div>

    </ng-container>

    <ng-template #noData>
        <div class="nodata">No Battle Events</div>
    </ng-template>
</div>


<!-- ========================================================== -->
<!-- JOINED TAB -->
<!-- ========================================================== -->

<div *ngIf="activePlayerTab === 'joinedc'">
    <ng-container *ngIf="ContestPlayerList?.length > 0; else noData">

        <div class="match-card" *ngFor="let item of ContestPlayerList">

            <div class="match-header">
                <h3 class="title">{{ item?.eventName }}</h3>

                <div class="header-right">
                    <div class="rule-icon" (click)="openRules(rulesmodal)" >
                        <img src="../../assets/images/icon/rule.fdb64234.svg" alt="" />
                    </div>
                </div>
            </div>

            <div class="gradient-border"></div>

            <div class="match-list-details">
                <div class="match-team">
                    <div class="match-team-list">

                        <div class="team-list-con live-heading">
                            <figure class="me-1"><img src="../../assets/images/icon/Team.png" class="imsgcard" alt=""></figure>
                            <h4 class="team-list-wet">
                                {{item?.eventName.split('vs')[0].trim() }}
                            </h4>
                        </div>

                        <div class="team-list-con live-heading justify-content-end">
                            <h4 class="team-list-wet text-end">
                                {{item?.eventName.split('vs')[1].trim() }}
                            </h4>
                            <figure class="ms-1"><img src="../../assets/images/icon/Team.png"  class="imsgcard"alt=""></figure>
                        </div>

                    </div>
                </div>
            </div>


            <!-- Joined Player Lists -->
            <div class="row player-row">

                <div class="col-6 Team-name List-player">
                    <span class="team">User Team List</span>

                    <ng-container *ngFor="let runner of item.runnerArray">
                        <div class="player-photo-list" *ngIf="runner.selected == 1">
                            <div class="player-box blue-boder-bg box-p">
                                <figure><img src="../../assets/images/icon/1193274.png" class="imsgcard imsfpadd"></figure>

                                <div class="player-con">
                                    <div class="name">{{ runner.runnerName }}</div>
                                    <div class="player-btn-boll">
                                        <a class="thm-but">Run</a>&nbsp;
                                        <span class="runsdtop">{{ runner.runs }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <div class="col-6 Team-name List-player">
                    <span class="team">Computer Team List</span>

                    <ng-container *ngFor="let runner of item.runnerArray">
                        <div class="player-photo-list" *ngIf="runner.selected == 2">
                            <div class="player-box green-boder-bg box-p justify-content-end text-end">
                                <div class="player-con">
                                    <div class="name-c" style="text-align: right;">{{ runner.runnerName }}</div>
                                    <div class="player-btn-boll">
                                        <a class="thm-but">Run</a>&nbsp;
                                        <span class="runsdtop">{{ runner.runs }}</span>
                                    </div>
                                </div>

                                <figure><img src="../../assets/images/icon/1193274.png" class="imsgcard imsfpadd"></figure>
                            </div>
                        </div>
                    </ng-container>

                </div>

            </div>

            <div class="team-result">
                <span>Stake : {{ item.stake }}</span>
            </div>

        </div>

    </ng-container>

    <ng-template #noData>
        <div class="nodata">No Battle Events</div>
    </ng-template>
</div>


<!-- ========================================================== -->
<!-- SETTLED TAB -->
<!-- ========================================================== -->

<div *ngIf="activePlayerTab === 'settledc'">
    <ng-container *ngIf="ContestPlayerList?.length > 0; else noData">

        <div class="match-card" *ngFor="let item of ContestPlayerList">

            <div class="match-header">
                <h3 class="title">{{ item?.eventName }}</h3>

                <div class="header-right">
                    <div class="rule-icon" (click)="openRules(rulesmodal)">
                        <img src="../../assets/images/icon/rule.fdb64234.svg" class="imsgcard" alt="" />
                    </div>
                </div>
            </div>

            <div class="gradient-border"></div>

            <div class="match-list-details">
                <div class="match-team">
                    <div class="match-team-list">

                        <div class="team-list-con live-heading">
                            <figure class="me-1"><img src="../../assets/images/icon/Team.png" class="imsgcard" alt=""></figure>
                            <h4 class="team-list-wet">
                                {{item?.eventName.split('vs')[0].trim() }}
                            </h4>
                        </div>

                        <div class="team-list-con live-heading justify-content-end ">
                            <h4 class="team-list-wet text-end">
                                {{item?.eventName.split('vs')[1].trim() }}
                            </h4>
                            <figure class="ms-1"><img src="../../assets/images/icon/Team.png" class="imsgcard" alt=""></figure>
                        </div>

                    </div>
                </div>
            </div>


            <!-- Settled Player Lists -->
            <div class="row player-row">

                <div class="col-6 Team-name List-player">
                    <span class="team">User Team List</span>

                    <ng-container *ngFor="let runner of mergeRunners(item).mergedRunners">
                        <div class="player-photo-list" *ngIf="runner.selected == 1">
                            <div class="player-box blue-boder-bg box-p justify-content-start text-start">
                                <figure><img src="../../assets/images/icon/1193274.png" class="imsgcard imsfpadd"></figure>

                                <div class="player-con">
                                    <div class="name">{{ runner.runnerName }}</div>
                                    <div class="player-btn-boll">
                                        <a class="thm-but">Run</a>&nbsp;
                                        <span class="runsdtop">{{ runner.runs }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <div class="col-6 Team-name List-player">
                    <span class="team">Computer Team List</span>

                    <ng-container *ngFor="let runner of mergeRunners(item).mergedRunners">
                        <div class="player-photo-list" *ngIf="runner.selected == 2">
                            <div class="player-box green-boder-bg box-p justify-content-end text-end">

                                <div class="player-con">
                                    <div class="name-c">{{ runner.runnerName }}</div>
                                    <div class="player-btn-boll">
                                        <a class="thm-but">Run</a>&nbsp;
                                        <span class="runsdtop">{{ runner.runs }}</span>
                                    </div>
                                </div>

                                <figure><img src="../../assets/images/icon/1193274.png" class="imsgcard imsfpadd"></figure>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>

            <div class="team-result">
                <span>User Total: {{ mergeRunners(item).userTotalRuns }}</span>
                <span>Computer Total: {{ mergeRunners(item).computerTotalRuns }}</span>
                <span>Stake: {{ item.stake }}</span>
                <span>
                    Result:
                    <span [ngClass]="item.result === 'LOST' ? 'Red' : 'Green'">
                        {{ item.result }} ({{ item.profit }})
                    </span>
                </span>
            </div>

        </div>

    </ng-container>

    <ng-template #noData>
        <div class="nodata">No Battle Events</div>
    </ng-template>
</div>

                    </div>
                </div>
            </div>
        </div>
            </div>
            </div>
            </div>


      <div style="margin-bottom: 8px;"></div>
      <!-- <ng-container *ngIf="!inplay">
        <div *ngIf="id==4" class="game-list-card">
          <div class="game-list-header">
           
            Go Casino

            <mat-divider class="didvide" [vertical]="true"></mat-divider>
          </div>
          <ul>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 3938
                </div>
                <img class="imgsize" (click)="openCasino('SPB-aviator')"
                  src="https://ss.manage63.com/south247/casinolobbyimages/aviator.jpg" alt="">

                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  Aviator 3D
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 6244
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://ss.manage63.com/south247/casinolobbyimages/blastoff.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  BlastOff
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 9376
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://ss.manage63.com/south247/casinolobbyimages/Trio.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  Trio
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 8171
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://ss.manage63.com/south247/casinolobbyimages/super-over.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  Super Over
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 170
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://ss.manage63.com/south247/casinolobbyimages/3-Card-Judgement.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  3 Card Judgement
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 2097
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://ss.manage63.com/south247/casinolobbyimages/Casino-War.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  Casino War
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 3488
                </div>
                <img class="imgsize" (click)="openCasino('EVO-dreamcatcher')"
                  src="https://ss.manage63.com/south247/casinolobbyimages/Dream-Catcher.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  Dream Catcher
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 341
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://ss.manage63.com/south247/casinolobbyimages/29-Card-Baccarat.jpg" alt="">
                <p class="namecasino">
                  Aura Casino
                </p>
                <p class="namecasinom">
                  29 Card Baccarat
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
          </ul>

        </div>
        <div *ngIf="id==5" class="game-list-card">
          <div class="game-list-header">

            Live Casino

            <mat-divider class="didvide" [vertical]="true"></mat-divider>
          </div>
          <ul>
            <li>
              <div class="imgframe">

                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 9954
                </div>
                <img class="imgsize" (click)="openCasino('EVO-autolightningroulette')"
                  src="https://cdn.dreamdelhi.com/dc/hindi_lightning_roulette.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Hindi Lightning Roulette
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 25L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 7467
                </div>
                <img class="imgsize" (click)="openCasino('EZU-automaticroulette')"
                  src="https://cdn.dreamcasino.live/evo_hindilightningroulette.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Hindi Lightning Roulette
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 25K
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 7668
                </div>
                <img class="imgsize" (click)="openCasino('EZU-sicbo')"
                  src="https://cdn.dreamcasino.live/evo_supersicbo.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Super Sic Bo
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 50K
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 5676
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://cdn.dreamdelhi.com/dc/gold_vault_roulette.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Gold Vault Roulette
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 10L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 9880
                </div>
                <img class="imgsize" (click)="openCasino('BTL-sicbo')"
                  src="https://cdn.dreamcasino.live/evolution/evo_emperorsicbo.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Emperor Sic Bo
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 13L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 1703
                </div>
                <img class="imgsize" (click)="openCasino('EVO-autolightningroulette')"
                  src="https://cdn.dreamcasino.live/evo_lightningroulette.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Lightning Roulette
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 25L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 9800
                </div>
                <img class="imgsize" (click)="openCasino('EVO-doubleballrou001')"
                  src="https://cdn.dreamcasino.live/evo_livedoubleballroulette.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  Double Ball Roulette
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 5L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 5077
                </div>
                <img class="imgsize" (click)="openCasino('EVO-americanroulette')"
                  src="https://cdn.dreamcasino.live/evo_liveamericanroulette.webp" alt="">
                <p class="namecasino">
                  Evolution Gaming
                </p>
                <p class="namecasinom">
                  American Roulette
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 25L
                </p>
              </div>
            </li>
          </ul>

        </div>
        <div *ngIf="id==6" class="game-list-card">
          <div class="game-list-header">
            
            Casino

            <mat-divider class="didvide" [vertical]="true"></mat-divider>
          </div>
          <ul>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 6043
                </div>
                <img class="imgsize" (click)="openCasino('SPB-aviator')"
                  src="https://cdn.dreamcasino.live/sbe_aviator.webp" alt="">
                <p class="namecasino">
                  Spribe
                </p>
                <p class="namecasinom">
                  Aviator
                </p>
                <p class="namecasino bottomi">
                  ₹10 - 8K
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 688
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://cdn.dreamdelhi.com/dc/gmz_dragons_secret.webp" alt="">
                <p class="namecasino">
                  Gamzix
                </p>
                <p class="namecasinom">
                  Dragons Secret
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 40K
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 5099
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://cdn.dreamdelhi.com/dc/gmz_the_hottest_game.webp" alt="">
                <p class="namecasino">
                  Gamzix
                </p>
                <p class="namecasinom">
                  The Hottest Game
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 50K
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 2124
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://cdn.dreamdelhi.com/dc/gmz_buffalo_coin_hold_the_spin.webp" alt="">
                <p class="namecasino">
                  Gamzix
                </p>
                <p class="namecasinom">
                  Buffalo Coin: Hold the Spin
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 20K
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 3963
                </div>
                <img class="imgsize" [routerLink]="['/casino']"
                  src="https://osgbook.com/assets/img/default-casino-img.png" alt="">
                <p class="namecasino">
                  Smartsoft Gaming
                </p>
                <p class="namecasinom">
                  Viking
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 1L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 1690
                </div>
                <img class="imgsize" [routerLink]="['/casino']" src="https://cdn.dreamdelhi.com/dc/sms_argo.webp"
                  alt="">
                <p class="namecasino">
                  Smartsoft Gaming
                </p>
                <p class="namecasinom">
                  Argo
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 1L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 1553
                </div>
                <img class="imgsize" [routerLink]="['/casino']" src="https://cdn.dreamdelhi.com/dc/sms_book_of_win.webp"
                  alt="">
                <p class="namecasino">
                  Smartsoft Gaming
                </p>
                <p class="namecasinom">
                  Book of Win
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 2L
                </p>
              </div>
            </li>
            <li>
              <div class="imgframe">
                <div class="usercount">
                  <mat-icon class="material-icons sizecasino">people</mat-icon> 8955
                </div>
                <img class="imgsize" [routerLink]="['/casino']" src="https://cdn.dreamdelhi.com/dc/sms_jetx3.webp"
                  alt="">
                <p class="namecasino">
                  Smartsoft Gaming
                </p>
                <p class="namecasinom">
                  Zetx3
                </p>
                <p class="namecasino bottomi">
                  ₹100 - 1L
                </p>
              </div>
            </li>
          </ul>

        </div>
      </ng-container>   -->
    </div>

    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #rulesmodal>
  <div class="modal-body">
    <mat-list class="setmat1">
      <div class="text-right"><a type="button" class="close1" data-dismiss="modal">
          <mat-icon (click)="modalRefcancel.hide()">close</mat-icon>
        </a>
      </div>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"> Rules</h5>
            </div>
<div class="rules-container">

 <div class="rules-tabs-wrapper">
  <ul class="nav nav-tabs rules-tabs" role="tablist">

    <li class="nav-item">
      <button 
        class="nav-link" 
        [class.active]="rulmodaltab === 'eng'"
        (click)="setrulesmodalTab('eng')">
        English
      </button>
    </li>

    <li class="nav-item">
      <button 
        class="nav-link" 
        [class.active]="rulmodaltab === 'kan'"
        (click)="setrulesmodalTab('kan')">
        Kannada
      </button>
    </li>

    <li class="nav-item">
      <button 
        class="nav-link" 
        [class.active]="rulmodaltab === 'tel'"
        (click)="setrulesmodalTab('tel')">
        Telugu
      </button>
    </li>

    <li class="nav-item">
      <button 
        class="nav-link" 
        [class.active]="rulmodaltab === 'hin'"
        (click)="setrulesmodalTab('hin')">
        Hindi
      </button>
    </li>

    <li class="nav-item">
      <button 
        class="nav-link" 
        [class.active]="rulmodaltab === 'guj'"
        (click)="setrulesmodalTab('guj')">
        Gujarati
      </button>
    </li>

  </ul>
</div>



  <!-- CONTENT AREA -->
  <div class="tab-content-box">

    <!-- English -->
    <div *ngIf="rulmodaltab === 'eng'" class="rules-language">
                                                      <p>You can create your team with minimum 1 player and maximum 6 players.
                                                </p>

                                                <p>2. Team bet- You can create your own team from among the given
                                                    players.</p>
                                                <p>&nbsp;</p>
                                                <p># If you select your player, the player of the opposite team will be
                                                    auto selected.</p>
                                                <p># After that you have to select your stake and how much rupees you
                                                    have to bet?</p>
                                                <p># EXP- If you have bet 100 rupees or your team's score is 100 runs or
                                                    the opposition team's score is 99 runs,
                                                    you will be winning by 5% or you will be 100 minus.</p>
                                                <p>&nbsp;</p>
                                                <p>3. Bet with Run- In this there is a bet per run.</p>
                                                <p>&nbsp;</p>
                                                <p># EXP- Per Run is a bet of Rs 100 and Max Run is selected 10, so your
                                                    exposure is Rs 1000 (10*100=1000)</p>
                                                <p># Your team has scored 100 runs or the opposite team has scored 20
                                                    runs to 80 runs. Your team is ahead but
                                                    your profit has been made of Rs 1000 because your max run has been
                                                    selected 10. # Or Opposite Team's Score
                                                    is 100 Run Or Your Team's Score is 80 Run To Opposite Team is ahead
                                                    by 80 Run In this case your loss will be
                                                    Rs 1000 because max run 10 has been selected (100*10=1000)</p>
                                                <p>4. Bet with Ball- In this you can bet on the ball to see whose team
                                                    will play more balls.</p>
                                                <p>&nbsp;</p>
                                                <p># Exp- Bet Rs 100 per ball or Max ball 10 is selected, your exposure
                                                    is 1000 (10*100=1000) # Your team has
                                                    played 100 balls or the opposite team has played 20 balls. Your team
                                                    is ahead of the ball but your profit
                                                    will be Rs 1000 because your max ball has been selected 10
                                                    (10*100=1000) # Or Opposite Team Has Played 100
                                                    Ball Or Your Team Has Played 80 Ball To Opposite's 80 Ball To
                                                    Opposite Team's 80 Ball Is In Case Me Your
                                                    Loss Will Come To 1000 Rs Because Max Ball 10 Has Been Selected
                                                    (100*10=1000)</p>
                                                <p>&nbsp;</p>
                                                <p>NOTE- If your player has played or scored 50 runs or the opposite
                                                    player has not come to bat or the next
                                                    player has come to bat or has not played even one ball, in this case
                                                    the result will be 0 for both your
                                                    player or the opposite player. In case the match has been canceled
                                                    by any person or the match has been
                                                    reduced by DLS method, then the result will come according to the
                                                    run in our case.</p>
                                                <p>Team Ball With Run And Ball With Ball.</p>
    </div>

    <!-- Kannada -->
    <div *ngIf="rulmodaltab === 'kan'" class="rules-language">
     <p>ಕನಿಷ್ಠ 1 ಆಟಗಾರರಿಂದ ನೀವು ನಿಮ್ಮ ತಂಡವನ್ನು ರೂಪಿಸಬಹುದು, ಗೌರವ 6 ಆಟಗಾರರಿಂದ ತಂಡವನ್ನು
                                            ರೂಪಿಸಬಹುದು.<br>2. ತಂಡ ಬೆಟ್ - ಇಲ್ಲಿ
                                            ನೀಡಿದ ಆಟಗಾರರಲ್ಲಿ ನೀವು ನಿಮ್ಮ ತಂಡವನ್ನು ರೂಪಿಸಬಹುದು.# ನೀವು ನಿಮ್ಮ ಆಟಗಾರರನ್ನು
                                            ಆಯ್ಕೆ ಮಾಡಿದಾಗ, ವಿರುದ್ಧ ತಂಡದ ಆಟಗಾರ ಮೂಲಕಲೇ
                                            ಆಯ್ಕೆ ಮಾಡಲಾಗುತ್ತದೆ.# ನಂತರ, ನೀವು ಲಗತ್ತನ್ನು ಆಯ್ಕೆ ಮಾಡಬೇಕು, ನೀವು ಎಷ್ಟು ರೂ ಬೆಟ್
                                            ಮಾಡಲು ಬಯಸುತ್ತೀರಿ ಎಂದು. # ಉದಾ: ನೀವು
                                            100 ರೂ ಬೆಟ್ ಮಾಡಿದ್ದೀರಿ, ಮತ್ತು ನಿಮ್ಮ ತಂಡದ ಸ್ಕೋರ್ 100 ಓಟ ಹಾಗೂ ವಿರುದ್ಧ ತಂಡದ
                                            ಸ್ಕೋರ್ 99 ಓಟ ಇದ್ದರೆ, ನಿಮ್ಮ ತಂಡ
                                            ಜಯಿಸುವುದು ಮತ್ತು 5% ವ್ಯತ್ಯಾಸವನ್ನು ಕಡಿತಗೊಳಿಸಿದ ನಂತರ 95 ರೂ ನೀವು ಲಾಭ
                                            ಗಳಿಸುತ್ತೀರಿ. ಆದರೆ, ವಿರುದ್ಧ ತಂಡದ ಸ್ಕೋರ್ 100
                                            ಮತ್ತು ನಿಮ್ಮ ತಂಡದ ಸ್ಕೋರ್ 99 ಇದ್ದರೆ, ನೀವು 100 ರೂ ಕಳೆದುಕೊಳ್ಳುತ್ತಾರೆ. &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp;<br>3.
                                            ಓಟದಲ್ಲಿ ಬೆಟ್ - ಇದರಲ್ಲಿ ಪ್ರತಿಯೊಂದು ಓಟಕ್ಕೆ ಒಬ್ಬರಿಗೊಬ್ಬರಿಗಾದ ಬೆಟ್ ಇರುತ್ತದೆ#
                                            ಉದಾಹರಣೆ - ಪ್ರತಿಯೋಂದು ಓಟಕ್ಕೆ 100 ರೂ.
                                            ಬೆಟ್ ಇದೆ ಮತ್ತು ನೀವು 10 ಅತಿಶಯ ಓಟವನ್ನು ಆಯ್ಕೆ ಮಾಡಿಕೊಂಡಿದ್ದರೆ, ನಿಮ್ಮ ಇಕ್ಸ್ಪೋಶರ್
                                            1000 ರackson (10*100=1000)# ನಿಮ್ಮ
                                            ತಂಡ 100 ಓಟಗಳೊಂದಿಗೆ ಅಂಕಗಳನ್ನು ಗಳಿಸಿದರೆ ಮತ್ತು ವಿರುದ್ಧ ತಂಡ 20 ಓಟಗಳೊಂದಿಗೆ
                                            ಅಂಕಗಳನ್ನು ಗಳಿಸಿದರೆ, ನೀವು 80 ಓಟಗಳಿಂದ ನಿಮ್ಮ
                                            ತಂಡ Ahead ಆದರೆ ನಿಮ್ಮ ಲಾಭ 1000 ರೂ. ಆಗಿರುತ್ತದೆ ಏಕೆಂದರೆ ನೀವು 10 ಅತಿಶಯ ಓಟವನ್ನು
                                            ಆಯ್ಕೆ ಮಾಡಿಕೊಂಡಿದ್ದೀರಿ# ಮತ್ತು ವಿರುದ್ಧ
                                            ತಂಡವು 100 ಓಟಗಳನ್ನು ಗಳಿಸಿದರೆ ಮತ್ತು ನಿಮ್ಮ ತಂಡವು 80 ಓಟಗಳನ್ನು ಗಳಿಸಿದ್ದರೆ,
                                            ಸಂಪೂರ್ಣ ತಂಡವು 80 ಓಟಗಳಿಂದ Ahead
                                            ಆಗಿರುವುದರಿಂದ ಈ ಪ್ರಕರಣದಲ್ಲಿ ನಿಮ್ಮ ಹಾನಿಯಾಗುವುದು 1000 ರೂ. ಏಕೆಂದರೆ 10 ಅತಿಶಯ
                                            ಓಟವನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ (100*10=1000).
                                            &nbsp;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; 4.ಬಾಲ್ ದಾಖಲಾತಿ- ಇದು
                                            ಪ್ರತಿಯೊಬ್ಬ ಬಾಲ್ ಗೆ ದಾಖಲೆ ಮಾಡಬಹುದು ಯಾವ ತಂಡ ಹೆಚ್ಚು ಬಾಲ್ ಆಡುತ್ತದೆ# ಉದಾಹರಣೆ-
                                            ಪ್ರತಿಯೊಬ್ಬ ಬಾಲ್ 100 ರೂಪಾಯಿಯ ದಾಖಲೆ ಇದೆ
                                            ಮತ್ತು ಗರಿಷ್ಠ ಬಾಲ್ 10 ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ ನಿಮ್ಮ ತನಕ ನಿಮ್ಮ ನಿರಾಕರಣೆ 1000
                                            ರೂಪಾಯಿಯಾಗಿದೆ (10*100=1000)# ನಿಮ್ಮ ತಂಡವು 100
                                            ಬಾಲ್ ಆಡಿದರೆ ಮತ್ತು ಎದುರಾಳಿ ತಂಡವು 20 ಬಾಲ್ ಆಡಿದರೆ ನಿಮ್ಮ ತಂಡವು ಬೇಲಿಯಲ್ಲಿದೆ ಆದರೆ
                                            ನಿಮ್ಮ ಲಾಭ 1000 ರೂಪಾಯಿಯಾಗುತ್ತದೆ
                                            ಏಕೆಂದರೆ ನೀವು ಗರಿಷ್ಠ 10 ವ್ಯತ್ಯಾಸವನ್ನು ಆಯ್ಕೆ ಮಾಡಿದ್ದೀರಿ (10*100=1000)# ಮತ್ತು
                                            ಎದುರಾಳಿ ತಂಡವು 100 ಬಾಲ್ ಆಡಿದರೆ ಮತ್ತು
                                            ನಿಮ್ಮ ತಂಡವು 80 ಬಾಲ್ ಆಡಿದೆ ಅEntão, 80 ಬಾಲ್ ಎದುರಾಳಿಯ ತಂಡದಿಂದ ಬರುವುದರಿಂದ ಈ
                                            ಸಂದರ್ಭದಲ್ಲಿ ನಿಮ್ಮ ನಷ್ಟ 1000
                                            ರೂಪಾಯಿಯಾಗುತ್ತದೆ ಏಕೆಂದರೆ ನೀವು ಗರಿಷ್ಠ 10 ವ್ಯತ್ಯಾಸವನ್ನು ಆಯ್ಕೆ ಮಾಡಿದ್ದೀರಿ
                                            (100*10=1000) &nbsp;
                                            &nbsp;&nbsp;<br>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; ಗಮನಿಸಿ- ನಿಮ್ಮ ಆಟಗಾರ ಆಟವಾಡಿದರೆ ಮತ್ತು 50 ಓಟಗಳನ್ನು ಮಾಡಿದರೆ
                                            ಮತ್ತು ವಿರುದ್ಧದ ಆಟಗಾರನ ಬ್ಯಾಟಿಂಗ್
                                            ಸಮಯಕ್ಕೆ ಬರುವುದಿಲ್ಲ ಅಥವಾ ಬ್ಯಾಟಿಂಗ್ ಮಾಡಲು ಬರುವುದಾದರೆ ಮತ್ತು ಒಂದು ಬೋಲ್‌ಗೂ
                                            ಆಟವಾಡದಿದ್ದರೆ, ಈ ಸಂದರ್ಭದಲ್ಲಿ ಖಾತರಿಯ ಯಶಸ್ಸು
                                            0 ಆಗುವುದು, ನಿಮ್ಮ ಆಟಗಾರನಿಗೂ ವಿರುದ ಆಟಗಾರನಿಗೂ. ಯಾವುದೇ ಕಾರಣದಿಂದ ಪಂದ್ಯಗಳು
                                            ನಿರಾಶಿತವಾದರೆ ಅಥವಾ DLS ವಿಧಾನದಿಂದ ಪಂದ್ಯ ಕಡಿಮೆ
                                            ವಿವರವಾಗಿದ್ದರೆ, ಈ ಸಂದರ್ಭದಲ್ಲಿ ಯಾವ ಅಂಶ ಮೂಲಕ ಓಟಗಳು ಮಾಡಲಾಗಿದೆ ಅದಕ್ಕೆ ಸಮಾನackson
                                            ಫಲಿತಾಂಶ ಬರುತ್ತದೆ. ತಂಡದ ಬಾಲ್
                                            ಓಟಗಳೊಂದಿಗೆ ಮತ್ತು ಬಾಲ್‌ಗೊಂದಿಗೆ.</p>
    </div>

    <!-- Telugu -->
    <div *ngIf="rulmodaltab === 'tel'" class="rules-language">
     <p>కనిష్ట 1 ఆటగాడు సే ఆప్ అప్నా టీమ్ బనా సక్తే హై మ్యాక్స్ 6 ప్లేయర్ సే టీమ్ బనా
                                            సక్తే హై</p>
                                        <p><br>2. టీమ్ బెట్- ఇస్మే దియే హే ప్లేయర్ మే సే ఆప్ అప్నీ టీమ్ బనా సక్తే
                                            హై&nbsp;<br><br># Jese ap apna Player
                                            ఎంచుకోండి కార్తే హై టీమ్ కా ప్లేయర్ ఎదురుగా ఆటో సెలెక్ట్ హో
                                            జాయేగా&nbsp;<br># ఉస్కే బాద్ ఆప్కో స్టేక్ సెలెక్ట్
                                            కర్నా హై ఆప్కో కిత్నే రూ కి బెట్ కర్నా హై&nbsp;<br># EXP- జేసే అప్నే బెట్
                                            కియా హై 100 రూ కా లేదా ఆప్కీ టీమ్ కా
                                            స్కోర్ హై 100 రన్ లేదా ఆపోజిట్ టీమ్ కా స్కోర్ హై 99 రన్ టు ఆప్కీ టీమ్ విన్
                                            హో జాయేగీ లేదా ఆప్కో 5% కట్ కర్ 95
                                            రూ. ఆప్కే ఐడి మి విన్నింగ్ కా 95 రూ ఆప్కే ఐడి మి విన్నింగ్ ఎఎ జాయేగీ 1 AA
                                            జాయేగీ 1 స్కోర్ Hai 99 నుండి Ap 100
                                            మైనస్ హో జాయేంగే</p>
                                        <p>&nbsp;</p>
                                        <p>3. పందెం విత్ రన్- ఇస్మే పర్ రన్ పర్ బెట్ హోతీ హై</p>
                                        <p># ఎక్స్‌ప్- పర్ రన్ 100 రూ కి బెట్ హై లేదా మ్యాక్స్ రన్ 10 కియా హై అప్నే తో
                                            అప్కా ఎక్స్‌పోజర్ 1000 కా హువా
                                            (10*100=1000) ఎంచుకోండి<br># ఆప్కీ టీమ్ నే స్కోర్ కియా 100 రన్ లేదా ఆపోజిట్
                                            టీమ్ నే స్కోర్ కియా 20 రన్ టు 80 రన్
                                            సే ఆప్కీ టీమ్ ఆగే హై లేకిన్ అప్కా ప్రాఫిట్ బనేగా 1000 రూ కా క్యుకీ అప్నే
                                            మ్యాక్స్ రన్ 10 సెలెక్ట్ కియా
                                            హై&nbsp;<br># లేదా ఆపోజిట్ టీమ్ కా స్కోర్ హై 100 రన్ లేదా ఆప్కీ టీమ్ కా
                                            స్కోర్ హై 80 రన్ టు ఆపోజిట్ టీమ్ 80 రన్
                                            సే ఆగే హై ఈజ్ కేస్ మీ అప్కా లాస్ ఆయేగా 1000 రూ క్యుకీ మ్యాక్స్ రన్ 10
                                            ఎంచుకోండి కియా హువా హై (100*10)</p>
                                        <p>4. బంతితో పందెం- ఇస్మే పర్ బాల్ పర్ బెట్ కర్ సక్తే హై కిస్కీ టీమ్ జ్యాదా బాల్
                                            ప్లే కరేగి</p>
                                        <p># ఎక్స్- పర్ బాల్ 100 రూ కి బెట్ హై లేదా మ్యాక్స్ బాల్ 10 కియా హై అప్నే తో
                                            అప్కా ఎక్స్‌పోజర్ 1000 కా హువా
                                            (10*100=1000) ఎంచుకోండి<br># ఆప్కీ టీమ్ నే 100 బాల్ ప్లే కియా లేదా వ్యతిరేక
                                            జట్టు నే 20 బాల్ ప్లే కియా ఆప్కీ
                                            టీమ్ ఆగే హై బాల్ లేకిన్ అప్కా ప్రాఫిట్ బనేగా 1000 రూ కా క్యుకీ అప్నే మాక్స్
                                            బాల్10 కియా హై (10*100=1000)
                                            ఎంచుకోండి&nbsp;<br># లేదా ఆపోజిట్ టీమ్ నే ప్లే కియా హై 100 బాల్ లేదా ఆప్కీ
                                            టీమ్ నే ప్లే కియా హై 80 బాల్ టు
                                            ఆపోజిట్ కే 80 బాల్ టు ఆపోజిట్ టీమ్ కే నిక్లే 80 బాల్ ఈజ్ కేస్ మి అప్కా లాస్
                                            ఆయేగా 1000 రూ హు హు హుకీ మ్యాక్స్
                                            బాల్ అప్నే హాయి 10 హాయి కియా ఎంచుకోండి (100*10=1000)</p>
                                        <p><br>గమనిక- ఏజర్ అప్కా ప్లేయర్ ప్లే కియా హై లేదా 50 రన్ బనాయా హై లేదా ఆపోజిట్
                                            ప్లేయర్ కి బ్యాటింగ్ నహీ ఆయీ హై యా
                                            ఎఫ్‌ఆర్ వో బ్యాటింగ్ కర్నే అయా హై ఓర్ ఏక్ భీ బాల్ ప్లే నహీ కియా హై ఈజ్ కేస్
                                            మి రిజల్ట్ 0 ఆయేగా డోనో కా ఆప్కే
                                            ప్లేయర్ కా భీ ఓర్ పోజిట్ ప్లే</p>
                                        <p>కేస్ కిసీ వాజా సే మ్యాచ్ అబాండనేడ్ హోతా హై యా Fhr మ్యాచ్ DLS మెథడ్ సే
                                            తగ్గించబడింది హో జాతా హై టు అస్ కేస్ మే జో
                                            రన్ బనే హై ఉస్కే హిసాబ్ సే హాయ్ రిజల్ట్ ఆయేగా&nbsp;<br>టీమ్ బాల్ విత్ రన్
                                            అండ్ బాల్ విత్ బాల్ కా</p>
    </div>

    <!-- Hindi -->
    <div *ngIf="rulmodaltab === 'hin'" class="rules-language">
      <p>आप कम से कम 1 खिलाड़ी और अधिकतम 6 खिलाड़ियों के साथ अपनी टीम बना सकते हैं।
                                        </p>
                                        <p>2. टीम बेट- आप दिए गए खिलाड़ियों में से अपनी टीम बना सकते हैं।</p>
                                        <p># अगर आप अपना खिलाड़ी चुनते हैं, तो विपरीत टीम का खिलाड़ी अपने आप चुन लिया
                                            जाएगा।</p>
                                        <p># उसके बाद आपको अपना दांव चुनना होगा और यह भी बताना होगा कि आपको कितने रुपये
                                            दांव पर लगाने हैं?</p>
                                        <p># EXP- अगर आपने 100 रुपये दांव पर लगाए हैं या आपकी टीम का स्कोर 100 रन है या
                                            विपक्षी टीम का स्कोर 99 रन है, तो आप
                                            5% से जीतेंगे या फिर 100 माइनस होंगे।</p>
                                        <p>3. रन के साथ बेट- इसमें प्रति रन बेट होती है।</p>
                                        <p># EXP- प्रति रन 100 रुपये की बेट होती है और अधिकतम रन 10 चुने जाते हैं, तो
                                            आपका एक्सपोजर 1000 रुपये (10*100=1000)
                                            होता है</p>
                                        <p># आपकी टीम ने 100 रन बनाए हैं या विपरीत टीम ने 20 रन से 80 रन बनाए हैं। आपकी
                                            टीम आगे है लेकिन आपको 1000 रुपये का
                                            लाभ हुआ है क्योंकि आपके अधिकतम रन 10 चुने गए हैं। # या विपरीत टीम का स्कोर
                                            100 रन है या आपकी टीम का स्कोर 80 रन
                                            है विपरीत टीम 80 रन से आगे है इस स्थिति में आपका नुकसान 1000 रुपये होगा
                                            क्योंकि अधिकतम रन 10 चुने गए हैं
                                            (100*10=1000)<br>4. बॉल के साथ दांव- इसमें आप बॉल पर दांव लगा सकते हैं कि
                                            किसकी टीम अधिक बॉल खेलेगी।</p>
                                        <p># एक्सप- प्रति बॉल 100 रुपये का दांव लगाएं या अधिकतम बॉल 10 चुनी जाती है,
                                            आपका एक्सपोजर 1000 है (10*100=1000) #
                                            आपकी टीम ने 100 बॉल खेली हैं या विपरीत टीम ने 20 बॉल खेली हैं। आपकी टीम गेंद
                                            से आगे है लेकिन आपका लाभ 1000 रुपये
                                            होगा क्योंकि आपकी अधिकतम गेंद 10 चुनी गई है (10*100=1000) # या विपक्षी टीम
                                            ने 100 गेंद खेली है या आपकी टीम ने
                                            विपक्षी टीम की 80 गेंद के मुकाबले 80 गेंद खेली है, इस स्थिति में आपका नुकसान
                                            1000 रुपये होगा क्योंकि अधिकतम गेंद
                                            10 चुनी गई है (100*10=1000)</p>
                                        <p>नोट- अगर आपका खिलाड़ी 50 रन खेल चुका है या बना चुका है या विपक्षी खिलाड़ी
                                            बल्लेबाजी करने नहीं आया है या अगला
                                            खिलाड़ी बल्लेबाजी करने आया है या उसने एक भी गेंद नहीं खेली है, तो इस स्थिति
                                            में आपके खिलाड़ी या विपक्षी खिलाड़ी
                                            दोनों के लिए परिणाम 0 होगा। अगर मैच किसी व्यक्ति द्वारा रद्द कर दिया गया है
                                            या मैच को DLS पद्धति से कम कर दिया
                                            गया है, तो हमारे मामले में परिणाम रन के अनुसार आएगा।<br>टीम बॉल विद रन और
                                            बॉल विद बॉल।</p>
    </div>

    <!-- Gujarati -->
    <div *ngIf="rulmodaltab === 'guj'" class="rules-language">
                                           <p>તમે ઓછામાં ઓછા 1 ખેલાડી સાથે તમારી ટીમ બનાવી શકો છો, તમે વધુમાં વધુ 6 ખેલાડીઓ
                                            સાથે તમારી ટીમ બનાવી શકો છો.</p>
                                        <p><br>2. ટીમ બેટ- આમાં તમે આપેલા ખેલાડીઓમાંથી તમારી ટીમ બનાવી શકો છો.<br># જેમ
                                            તમે તમારા ખેલાડીને પસંદ કરશો, વિરોધી
                                            ટીમનો ખેલાડી ઓટો સિલેક્ટ થઈ જશે.<br># તે પછી તમારે બેટ્સ પસંદ કરવાનું રહેશે
                                            અને તમે કેટલા રસ પર દાવ લગાવવા માંગો
                                            છો.<br># દા.ત- જો તમે 100 રૂપિયા પર દાવ લગાવો છો અથવા તમારી ટીમનો સ્કોર 100
                                            રન છે અથવા વિરોધી ટીમનો સ્કોર 99 રન
                                            છે, તો તમે 5% થી જીતી જશો અથવા તમે 100 માઈનસ થઈ જશો.<br>3. રન સાથે શરત- આમાં
                                            પ્રતિ રન એક શરત છે.</p>
                                        <p># દા.ત- રૂ 100 ની પ્રતિ રન બેટ અથવા મહત્તમ રન પસંદ કરેલ 10 તમારું એક્સપોઝર
                                            1000 છે (10*100=1000) # તમારી ટીમે 100
                                            રન બનાવ્યા છે અથવા સામેની ટીમે 20 રનથી 80 રન બનાવ્યા છે. તમારી ટીમ આગળ છે
                                            પરંતુ તમારો નફો રૂ. 1000 થયો છે કારણ
                                            કે તમારો મહત્તમ રન 10 પસંદ કરવામાં આવ્યો છે. # અથવા વિરોધી ટીમનો સ્કોર 100
                                            રન છે અથવા તમારી ટીમનો સ્કોર 80 રન છે
                                            સામેની ટીમ 80 રનથી આગળ છે આ કિસ્સામાં તમારું નુકસાન રૂ. 1000 થશે કારણ કે
                                            પસંદ કરેલ મહત્તમ રન 10
                                            છે.<br>(100*10=1000)</p>
                                        <p>4. બોલ સાથે શરત- આમાં તમે બોલ પર શરત લગાવી શકો છો કે કોની ટીમ વધુ બોલ રમશે.
                                        </p>
                                        <p>&nbsp;</p>
                                        <p><br>નોંધ- જો તમારો ખેલાડી 50 રન રમ્યો હોય અથવા બનાવ્યો હોય અથવા સામેનો ખેલાડી
                                            બેટિંગ કરવા આવ્યો ન હોય અથવા પછીનો
                                            ખેલાડી બેટિંગ કરવા આવ્યો હોય અથવા એક પણ બોલ ન રમ્યો હોય, તો આ કિસ્સામાં
                                            પરિણામ તમારા ખેલાડી અથવા સામેના ખેલાડી
                                            બંને માટે 0 હશે.</p>
                                        <p>જો કોઈ વ્યક્તિ દ્વારા મેચ રદ કરવામાં આવી હોય અથવા DLS પદ્ધતિથી મેચમાં ઘટાડો
                                            કરવામાં આવ્યો હોય, તો પરિણામ અમારા
                                            કેસમાં રન અનુસાર આવશે. રન સાથે ટીમ બોલ અને બોલ સાથે બોલ</p>
    </div>

  </div>

</div>

        </mat-list>
        </div>

</ng-template>
